import React from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

export const AuthorizeRoute = ({ children }: { children: JSX.Element }) => {
    var auth = React.useContext(AuthContext); 

    if (auth.isAuthenticated()) {
        return children;
    } else {
        auth.signinRedirect(null, window.location.pathname);
        return <AbpnSpinner/>;
    }

}